module.exports = __webpack_public_path__ + "img/24.c8cea3d9.webp";